import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-active",
  "use": "icon-active-usage",
  "viewBox": "0 0 38 16",
  "content": "<symbol viewBox=\"0 0 38 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-active\">\n\n        <path d=\"M0 8C0 3.58172 3.58172 0 8 0H30C34.4183 0 38 3.58172 38 8V8C38 12.4183 34.4183 16 30 16H1C0.447716 16 0 15.5523 0 15V8Z\" fill=\"#F27400\" />\n        <text x=\"19\" y=\"8\" dominant-baseline=\"central\" font-family=\"PingFang SC, Lantinghei SC, Microsoft YaHei, sans-serif\" font-size=\"9\" fill=\"white\" text-anchor=\"middle\" letter-spacing=\"0.5\">已开启</text>\n\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol